module.exports = {
          srcSet: "/_next/static/images/apple_logo_white-25-856cad43c1bcc79d568f4a2522d8986c.png"+" 25w",
          images:[ {path: "/_next/static/images/apple_logo_white-25-856cad43c1bcc79d568f4a2522d8986c.png",width: 25,height: 25}],
          src: "/_next/static/images/apple_logo_white-25-856cad43c1bcc79d568f4a2522d8986c.png",
          toString:function(){return "/_next/static/images/apple_logo_white-25-856cad43c1bcc79d568f4a2522d8986c.png"},
          placeholder: undefined,
          width: 25,
          height: 25
      }